import { useDispatch, useSelector } from "react-redux";
import { clearSelectedId, clearTypeModal, clearTypeOfShowModalType } from "../../features/modal/modalSlice";
import { resetNewPackageTitleData, resetPackageState, selectCurrentPackageItems, selectedNewPackageTitleData, selectPackageDetailsAction, selectPackagedId, selectPackageStatus,  setPackageDetails,  setPackageStatus } from "../../features/package/packageSlice";
import { useMutationData } from "../api/useMutationData";
import { showToast } from "../../toastify/Toast";
import { handleApiError } from "../../utils/handleApiError";
import { UpdatePackageItemRequestBody } from "../../features/package/packageRequestBody";
import { ProductPackage } from "../../types/package";
import { clearSelectedProductToAddQty } from "../../features/product/productSlice";

export default function usePackageAction() {

    const dispatch = useDispatch()
    const selectedPackageId = useSelector(selectPackagedId);
    const packageDetailsAction = useSelector(selectPackageDetailsAction);
    const typeOfPackageAction = packageDetailsAction.packageType;
    const typOfAction = packageDetailsAction.typeOfAction;
    const currentStatus = useSelector(selectPackageStatus);
    const newPackageTitleData = useSelector(selectedNewPackageTitleData);
    const currentPackageItems = useSelector(selectCurrentPackageItems);
    const { updatePackageStatus, updateSpecialPackageStatus, createPackage, createNewPackageItems,updatePackageItems,  updatePackageDetails} = useMutationData()

    const handleCancelUpdatePackageStatus = () => {
        dispatch(clearTypeOfShowModalType())
        dispatch(setPackageStatus({packageName: '', status: null}))
    }
    
    const handleUpdatePackageStatus = async () => {
        if(!selectedPackageId) return
        if(!currentStatus.status) return

        try {
            if(typeOfPackageAction === 'special') {
                await updateSpecialPackageStatus({ packageId: selectedPackageId, type: currentStatus.status}).unwrap()
                showToast('Package status update successfully.', 'success')
                dispatch(clearTypeOfShowModalType())
                dispatch(resetPackageState())
                dispatch(setPackageDetails({packageType: null, typeOfAction: null}))
                return
            }
            await updatePackageStatus({ packageId: selectedPackageId, type: currentStatus.status}).unwrap()
            showToast('Package status update successfully.', 'success')
            dispatch(clearTypeOfShowModalType())
            dispatch(resetPackageState())
        } catch (error) {
            handleApiError(error, "Failed to update package status.");
        }
    }

    const handleSaveCupBasedPackage = async () => {
        if (!newPackageTitleData.packageName || !newPackageTitleData.quantity || !newPackageTitleData.totalValue ) {
            showToast("Please set package name, cups, and amount.", "info");
            return;
        }

        try {
            if (typOfAction === "newPackage") {
                const result = await createPackage(newPackageTitleData).unwrap();
                const packageID = result.packageID;

                if (!packageID) {
                    showToast("No package ID returned", "error");
                    return;
                }

                const productIDs = currentPackageItems.map((item: any) => item.productId);

                await createNewPackageItems({ packageID, productIDs }).unwrap();

                showToast("Package created successfully", "success");
            }

            if (typOfAction === "updatePackage") {
                if (!selectedPackageId) return;

                const payload: UpdatePackageItemRequestBody = {
                    packageId: selectedPackageId,
                    products: currentPackageItems.map((item: ProductPackage) => ({
                        productID: item.productId,
                    })),
                };

                await Promise.all([
                    updatePackageDetails({
                        packageId: selectedPackageId,
                        packageDetails: {
                            packageName: newPackageTitleData.packageName,
                            quantity: newPackageTitleData.quantity,
                            totalValue: newPackageTitleData.totalValue,
                        },
                    }).unwrap(),
                    updatePackageItems(payload).unwrap(),
                ]);
                showToast("Package updated successfully", "success");
            }

            dispatch(clearTypeModal());
            dispatch(clearSelectedProductToAddQty());
            dispatch(clearTypeOfShowModalType());
            dispatch(clearSelectedId());
            dispatch(resetNewPackageTitleData());
            dispatch(resetPackageState());
        } catch (error) {
            handleApiError(error, "Failed to save package.");
        }
    }

    return {
        handleCancelUpdatePackageStatus,
        handleUpdatePackageStatus,
        handleSaveCupBasedPackage,
    }
}